export function updateNavFor(){
	if(this.config.options.navFor){
		this.config.options.navFor.changeSlide(this.currentSlide);
	}
}

export function updateArrowClasses(){
	if(!this.config.options.arrows || this.config.options.infinite){
		return;
	}

	if(this.currentSlide == 0){
		this.elements.prevArrow.classList.add(this.config.classes.disabledArrow);
	}else{
		this.elements.prevArrow.classList.remove(this.config.classes.disabledArrow);
	}

	if(this.currentSlide == this.maxSlideScroll - 1){
		this.elements.nextArrow.classList.add(this.config.classes.disabledArrow);
	}else{
		this.elements.nextArrow.classList.remove(this.config.classes.disabledArrow);
	}
}

export function updateArrows(){
	if(!this.config.options.arrows || this.config.options.infinite){
		return;
	}

	if(this.currentSlide == 0){
		this.elements.prevArrow.disabled = true;
	}else{
		this.elements.prevArrow.disabled = false;
	}

	if(this.currentSlide == this.maxSlideScroll - this.config.options.slidesToShow){
		this.elements.nextArrow.disabled = true;
	}else{
		this.elements.nextArrow.disabled = false;
	}
}

export function updateDots(){
	if(!this.config.options.dots){
		return;
	}

	let currentSlide = this.currentSlide;
	if(this.config.options.infinite){
		if(currentSlide == this.slideCount){
			currentSlide = 0;
		}
		if(currentSlide == -this.config.options.slidesToShow){
			currentSlide = this.slideCount - 1;
		}
	}

	this.elements.dots.map((el, index) => {
		if(index == currentSlide){
			el.classList.add(this.config.classes.activeDot);
		}else{
			el.classList.remove(this.config.classes.activeDot);
		}
	});
}



// WEBPACK FOOTER //
// ./node_modules/ui-slider/app/js/src/slider/updates.js